import { AnimaliaTaxonomyFilterKey } from '../ports/AnimaliaListRepositoryPort';

interface AnimaliaListingTaxonomyImageLicense {
  readonly name: string | null;
  readonly url: string | null;
  readonly artist: string | null;
  readonly credit: string | null;
  readonly attributionRequired: boolean;
  readonly source: string | null;
}

interface AnimaliaListingTaxonomyImage {
  readonly src: string;
  readonly alt: string;
  readonly license: AnimaliaListingTaxonomyImageLicense | null;
}

export interface AnimaliaListingTaxonomySection {
  readonly title: string;
  readonly body: string;
}

export class AnimaliaListingTaxonomy {
  constructor(
    public readonly key: AnimaliaTaxonomyFilterKey,
    public readonly value: string,
    public readonly title: string,
    public readonly summary: string | null,
    public readonly description: string | null,
    public readonly image: AnimaliaListingTaxonomyImage | null,
    public readonly sections: ReadonlyArray<AnimaliaListingTaxonomySection>,
    public readonly wikipediaUrl: string | null,
    public readonly completed: boolean,
  ) {}
}
